
//IE polyfill
require( 'nodelist-foreach-polyfill' );

var faqHandler = function() {    
    const faq = document.querySelectorAll('.faq');

    var init = function() {
        if( faq ) {
            handleFAQs();
        }       
    }      


    /*FUNCTIONS
    #######################################**/

    function handleFAQs() {

        const faqs = document.querySelectorAll('.grid-faq .border-wrap');
       
        faqs.forEach( function( elem ) {           
            elem.addEventListener( 'click', function(e) {
                e.preventDefault();
                if( !window.getSelection().toString() ) {
                    elem.classList.toggle('open');
                }
            } );
        } );
    }

    return {init:init}
}();


document.addEventListener("DOMContentLoaded", function(){
    faqHandler.init();
});



